import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import DiscountService from "../../services/OrderingServices/DiscountService";

// Async thunk for API call
export const fetchDiscountAvailable = createAsyncThunk(
  "discounts/fetchDiscountAvailable",
  async (_, { rejectWithValue }) => {
    try {
      const response = await DiscountService.getAvailableDiscounts();
      return response || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const discountSlice = createSlice({
  name: "discounts",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearDiscounts: (state) => {
      state.data = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDiscountAvailable.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDiscountAvailable.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchDiscountAvailable.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDiscounts } = discountSlice.actions;
export default discountSlice.reducer;
